export default __webpack_public_path__ + "static/media/03_March.7e662075.png";